import { DashboardStatCard } from "@/modules/dashboard/presentation/ui/DashboardStatCard";
import { Link } from "@tanstack/react-router";
import { format, subDays } from "date-fns";
import { PercentIcon, TimerIcon } from "lucide-react";
import { useMemo } from "react";
import { usePerformanceRequestReportQuery } from "../api/queries";

export function PerformanceDashboardAnalyticsStrip() {
  const query = useMemo(() => {
    const dateTo = format(new Date(), "yyyy-MM-dd");
    const dateFrom = format(subDays(new Date(), 30), "yyyy-MM-dd");
    return { dateFrom, dateTo, offset: 0, limit: 1 };
  }, []);

  const { data, isLoading } = usePerformanceRequestReportQuery(query);
  const summary = data?.summary;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:items-stretch">
      <Link
        to="/app/performance/reports/requests"
        className="block h-full rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <DashboardStatCard
          title="ອັດຕາກາຍເປັນງານ (30 ວັນ)"
          tone="students"
          icon={PercentIcon}
          isLoading={isLoading}
          value={
            <span>
              {summary?.conversionRate ?? 0}
              <span className="font-medium text-lg">%</span>
            </span>
          }
        />
      </Link>

      <Link
        to="/app/performance/reports/requests"
        className="block h-full rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <DashboardStatCard
          title="ຄຳຂໍຄ້າງ &gt; 7 ວັນ"
          tone="refunds"
          icon={TimerIcon}
          isLoading={isLoading}
          value={(summary?.openOverdueCount ?? 0).toLocaleString()}
        />
      </Link>
    </div>
  );
}
